import api from '../../plugins/api';

// GET /api/crm/cars/stockImport/vin/{vin} — все упоминания VIN в отчётах импорта:
// ответ на вопрос «почему этой машины нет на витрине».
const getStockImportByVin = (vin) => {
  return api.get(`/api/crm/cars/stockImport/vin/${encodeURIComponent(vin)}`);
};

export default getStockImportByVin;
